import { outlinedWarningAmber } from '@quasar/extras/material-icons-outlined';
import { Notify } from 'quasar'

export class WarningMessage {
  static show(message: string): void {
    Notify.create({
      type: 'warning',
      icon: outlinedWarningAmber,
      message: message,
      html: true,
      progress: true,
      position: 'top',
    });
  }
}
